<template>
  <div>
    <v-dialog v-model="open" persistent max-width="600px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="headline">{{
            t("enviarTemplate")
          }}</v-card-title>
          <v-card-text>
            <v-select
              v-model="template"
              :label="t(`templates`)"
              :items="templatesName"
              required
              :rules="[(v) => !!v || 'Campo obrigatório']"
            ></v-select>
            <div v-if="template">
              <v-text-field
                v-for="(value, key) in getTemplateByName().fields"
                :key="key"
                v-model="templateForm[`${value}`]"
                :label="value"
                required
                :rules="[(v) => !!v || 'Campo obrigatório']"
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="send()">{{
              t("continuar")
            }}</v-btn>
            <v-btn color="error" text @click="cancelar()">{{
              t("cancelar")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar v-model="snackbar" color="error" bottom>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar = false">{{
          t("ok")
        }}</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
   
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
export default {
  name: "Transferencia",
  props: {
    open: { type: Boolean, default: false },
    item: { type: Object, default: null },
    new: { type: Boolean, default: false },
  },
  data() {
    return {
      template: null,
      valid: false,
      templateForm: {},
      filas: [],
      filasAgente: [],
      snackbar: false,
      snackbarText: null,
    };
  },
  watch: {
    open(nw) {
      if (nw) {
        //this.newWhats();
        this.getTemplates({ queue: this.atendimento.queue });
      }
    },
  },
  created() {
    // if(this.token) this.$router.push("/main");
  },
  computed: {
    ...mapState("xc", {
      cliente: (state) => state.cliente,
      agentes: (state) => state.agentes,
      atendimento: (state) => state.atendimento,
      templates: (state) => state.templates,
    }),
    templatesName() {
      if (!this.templates) return;
      return this.templates.map((t) => t.name);
    },
    ...mapState("auth", {
      user: (state) => state.user,
    }),
  },

  methods: {
    ...mapActions("xc", [
      "getDefault",
      "updateCliente",
      "transfereAtendimento",
      "setTransferenciaModal",
      "newWhatsApp",
      "getTemplates",
    ]),
    cancelar() {
      this.$emit("update", false);
    },
    send() {
      if (!this.$refs.form.validate()) return;
      let template = {};
      template.templateId = this.getTemplateByName().id;
      template.message = this.getTemplateByName().text;
      template.fields = this.templateForm;
      //return console.log(template);
      this.$emit("sendTemplate", template);
    },
    getTemplateByName() {
      if (!this.template) return null;
      let that = this;
      return this.templates.find((t) => t.name === that.template);
    },
  },
};
</script>
<style>
</style>